import { log, logger } from 'handlebars';
import React from 'react'

export default function ReturnsPreFormButtons({retailer,
                                               providesBoxLabel,
                                               toggleCreateNewLabel,
                                               isStoreComponents,
                                               isLockersComponents,
                                               setIsStoreComponents,
                                               setIsLockersComponents,
                                               setRetailerIntroduction,
                                               setRetailerDimensions,
                                               setPreFormContent,
                                               setPostFormContent,
                                            }) {

  return (

    <div>
        {!isStoreComponents && !isLockersComponents &&
            <>
                {providesBoxLabel &&
                    <p>
                        <strong>{"Can't find the returns label?"}</strong>
                    </p>
                }
                <div className="retailer__print-option-buttons">
                    <a className="yodel-outline-button"
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            toggleCreateNewLabel()
                        }}>{"Create a new label"}</a>
                </div>
            </>
        }

        {isStoreComponents && isLockersComponents &&
            <>
                <p className="retailer__create-label-button-info-text">
                    <strong>Choose return method</strong>
                </p>

                <div className="retailer__print-option-buttons">
                    <a className="yodel-outline-button -inpost-style retailer__print-option-button"
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            setIsStoreComponents(false);
                            setIsLockersComponents(true);
                            setRetailerIntroduction(retailer.lockersIntroduction);
                            setRetailerDimensions(retailer.lockersDimensionsAndPinsOverrideContent);
                            setPreFormContent(retailer.lockersPreFormContent);
                            setPostFormContent(retailer.lockersPostFormContent);
                            toggleCreateNewLabel();
                        }}>
                        InPost Locker
                    </a>

                    <a className="yodel-outline-button retailer__print-option-button"
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            setIsStoreComponents(true);
                            setIsLockersComponents(false);
                            setRetailerIntroduction(retailer.storesIntroduction);
                            setRetailerDimensions(retailer.storesDimensionsAndPinsOverrideContent);
                            setPreFormContent(retailer.storesPreFormContent);
                            setPostFormContent(retailer.storesPostFormContent);
                            toggleCreateNewLabel();
                        }}>
                        Yodel Store
                    </a>
                </div>
            </>
        }
    </div>
  )
}
